import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=c87b602c&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"
import style0 from "./radio.vue?vue&type=style&index=0&id=c87b602c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b602c",
  null
  
)

export default component.exports